// Currency Converter Component
import React, { useState, useEffect } from 'react';
import { useGeoLocation } from '../utils/useGeoLocation';

const CurrencyConverter = ({ 
  priceINR, 
  className = '',
  size = 'medium' 
}) => {
  const {
    convertPrice,
    userCurrency,
    getCurrencySymbol,
    isLoading
  } = useGeoLocation();

  const [selectedCurrency, setSelectedCurrency] = useState(userCurrency);
  const [convertedPrice, setConvertedPrice] = useState(null);

  // Update converted price when currency or price changes
  useEffect(() => {
    if (priceINR && selectedCurrency) {
      const converted = convertPrice(priceINR, selectedCurrency);
      setConvertedPrice(converted);
    }
  }, [priceINR, selectedCurrency, convertPrice]);

  // Update selected currency when user currency changes
  useEffect(() => {
    setSelectedCurrency(userCurrency);
  }, [userCurrency]);

  if (isLoading) {
    return (
      <div className={`currency-converter loading ${className}`}>
        <div className="price-skeleton">
          <div className="skeleton-price"></div>
        </div>
      </div>
    );
  }

  const sizeClasses = {
    small: 'converter-sm',
    medium: 'converter-md', 
    large: 'converter-lg'
  };

  return (
    <div className={`currency-converter ${sizeClasses[size]} ${className}`}>
      <div className="price-display">
        <span className="currency-symbol">
          {convertedPrice ? getCurrencySymbol(convertedPrice.currency) : '₹'}
        </span>
        <span className="price-amount">
          {convertedPrice ? convertedPrice.amount : priceINR}
        </span>
      </div>

      <style jsx>{`
        .currency-converter {
          position: relative;
          display: inline-block;
        }

        .currency-converter.loading .skeleton-price {
          width: 80px;
          height: 24px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
        }

        @keyframes loading {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }

        .price-display {
          display: inline;
        }

        .currency-symbol,
        .price-amount {
          font-weight: inherit;
          font-size: inherit;
          color: inherit;
          font-family: inherit;
        }

        /* Remove any default margins/padding */
        .price-display * {
          margin: 0;
          padding: 0;
        }
      `}</style>
    </div>
  );
};

export default CurrencyConverter;
